<script>
export default {
  props: ['route'],
  methods: {
    historyBack () {
      if (this.$route.hash) {
        this.$router.push({name: this.$route.name})
      } else {
        this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent)
        // this.$router.go(-1)
      }
    },
    setEsc (event) {
      if (event.keyCode === 27) {
        this.historyBack()
      }
    }
  },
  created () {
    window.addEventListener('keydown', this.setEsc)
  },
  destroyed () {
    window.removeEventListener('keydown', this.setEsc)
  }
}
</script>

<template>
  <div class="gp-modal">
    <div class="modal-background"></div>
    <slot></slot>
    <div class="close" @click="historyBack">
      <img src="@/assets/icon-modal-close.svg">
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  z-index: 12;
  .modal-background {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .close {
    background-color: $black;
    cursor: pointer;
    position: fixed;
    top: 0;
    right: 0;
    color: $white;
    z-index: 1;
    @include is-not-mobile {
      width: 140px;
      height: 80px;
    }
    @include is-mobile {
      width: 5.25rem;
      height: 3rem;
    }
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/modal.vue